import Vue from 'vue';
import Vuetify from 'vuetify/lib';


Vue.use(Vuetify);

// Francais
import fr from 'vuetify/es5/locale/fr'

export default new Vuetify({
    lang: {
        locales: { fr },
        current: 'fr',
      },
});
